import React, { useState, useEffect } from "react";
import ReviewOrderTab from "./ReviewOrder";
import PersonalInformationTab from "./PersonalInformation";
import PaymentDetailsTab from "./PaymentDetails";
import DeliveryAddressTab from "./DeliveryAddress";
import ExchangeDetailsTab from "./ExchangeDetails";
import Header from "../../lib/Common/Header";
import styles from "../../lib/Common/commonStyles";
import Footer from "../../lib/Common/Footer";
import { Check, ChevronDown, ChevronRight } from "lucide-react";
import { getMarketingPartners } from "../../apis/customer";
import { useTranslation } from "react-i18next";

const StepperForm = ({ values, setStep, formData, setFormData }) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [backStep, setBackStep] = useState(0);
  const [showSave, setShowSave] = useState(false);
  const [providers, setProviders] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  const steps = [
    {
      key: "personal",
      label:
        values?.customerType === "business"
          ? "Company Information"
          : "Personal Information",
      title: "Great! Now we just need some details from you.",
    },
    {
      key: "delivery",
      label: "Delivery Address",
      title: "What is the full delivery address?",
    },
    {
      key: "exchange",
      label: "Exchange Details",
      title: "What is your switching information?",
    },
    {
      key: "payment",
      label: "Payment Details",
      title: "How would you like to pay?",
    },
    {
      key: "review",
      label: "Review & Order",
      title: "Review over your order and pay below.",
    },
  ];

  const getProviders = async () => {
    const data = await getMarketingPartners();
    if (data?.success) {
      if (data.result.length > 0) {
        const providers = data?.result;
        const providerOptionsArray = providers.map((name) => ({
          value: name[0],
          label: name[1],
        }));
        setProviders(providerOptionsArray);
      }
    }
  };
  React.useEffect(() => {
    getProviders();
  }, []);

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <PersonalInformationTab
            formData={formData}
            updateFormData={setFormData}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            values={values}
            setStep={setStep}
            showSave={showSave}
            backStep={backStep}
          />
        );
      case 1:
        return (
          <DeliveryAddressTab
            formData={formData}
            updateFormData={setFormData}
            currentStep={currentStep}
            values={values}
            setCurrentStep={setCurrentStep}
            showSave={showSave}
            backStep={backStep}
          />
        );
      case 2:
        return (
          <ExchangeDetailsTab
            formData={formData}
            updateFormData={setFormData}
            currentStep={currentStep}
            values={values}
            setCurrentStep={setCurrentStep}
            showSave={showSave}
            providers={providers}
            backStep={backStep}
          />
        );
      case 3:
        return (
          <PaymentDetailsTab
            formData={formData}
            updateFormData={setFormData}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            showSave={showSave}
            backStep={backStep}
            values={values}
          />
        );
      case 4:
        return (
          <ReviewOrderTab
            formData={formData}
            updateFormData={setFormData}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            setStep={setStep}
            values={values}
            setShowSave={setShowSave}
            setBackStep={setBackStep}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Header contract={true} />
      {/* min-vh-100 */}
      {/* Cuurent Step -- {currentStep} */}
      <div className=" responsive-padding backgroundColorCommon">
        <div className="container-xl mx-auto maxWidth800">
          {/* Header */}
          <div className="text-start mb-2 mb-md-5 px-2 px-md-2 ">
            <h1 className="margin-bottom-70px textGreen fontSize32Bold lineHeight38 text-start ">
              {t(`${steps[currentStep]?.title}`)}
            </h1>
          </div>
          <div className=" mb-4 mb-md-5 ">
            <div className="position-relative">
              <div className="position-absolute stepper-form-mobile-container height1 backgroundColorLightGray" />

              {/* Steps  */}
              <div className="d-flex justify-content-between align-items-start">
                {steps.map((step, index) => (
                  <div
                    key={step.key}
                    className="d-flex flex-column align-items-center"
                    style={{ flex: "0 0 auto" }}
                  >
                    <div
                      className="rounded-circle d-flex justify-content-center align-items-center text-white fontSize32RegularSmall  position-relative stepper-form-mobile mob-pb-1"
                      style={{
                        backgroundColor:
                          index < currentStep
                            ? "#23DC9F"
                            : index === currentStep
                            ? "#FF53FF"
                            : "#431F66",
                        border: `1px solid ${
                          index < currentStep ? "#23DC9F" : "#FF53FF"
                        }`,
                        zIndex: 2,
                      }}
                    >
                      {index < currentStep ? (
                        <div
                          onClick={() => {
                            if (index < currentStep && currentStep < 4) {
                              setCurrentStep(index);
                            }
                          }}
                        >
                          <Check className="responsive-check-icon mb-1" />
                        </div>
                      ) : (
                        index + 1
                      )}
                    </div>

                    <div className="text-white text-center mt-2  maxWidth85 fontSize12Regular lineHeight18 break-word">
                      {t(`${step?.label}`)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* Please do not remove this commented code , need for Future reference (Multi language)   if required */}

          {/* Mobile Stepper */}
          {/* <div className="d-sm-none ">
            <div className="backgroundColorCommon rounded p-2">
              <div className="mb-1 md:mb-3">
                <h6 className="mb-1 text-white fontSize14Regular lineHeight24">
                  Step {currentStep + 1}:{" "}
                  <span className="text-white fontSize14Regular lineHeight24">
                    {steps[currentStep]?.label}
                  </span>
                </h6>
              </div>

              <div
                className="d-flex align-items-center pb-1 pb-md-3 overflow-auto"
                style={{
                  scrollbarWidth: "thin",
                  scrollbarColor: "rgb(35, 220, 159) transparent",
                  msOverflowStyle: "none",
                  WebkitOverflowScrolling: "touch",
                }}
              >
                {steps.map((step, index) => (
                  <div
                    key={step.key}
                    className="d-flex align-items-center flex-shrink-0 "
                  >
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center text-white fontSize14Regular lineHeight24 width30 height30"
                      style={{
                        color: index < currentStep ? "#482783" : "#421F66",
                        border: `1px solid ${index < currentStep ? "#23DC9F" : "#FF53FF"
                          }`,
                        backgroundColor:
                          index < currentStep
                            ? "#23DC9F"
                            : index === currentStep
                              ? "#FF53FF"
                              : "#421F66",
                      }}
                    >
                      {index < currentStep ? (
                        <Check size={16} className="text-blue" />
                      ) : (
                        index + 1
                      )}
                    </div>

                    {index < steps.length - 1 && (
                      <div
                        className="stepper-form-mobile justify-content-center align-items-center align-self center"
                        style={{
                          backgroundColor:
                            index < currentStep
                              ? "#23DC9F"
                              : index === currentStep
                              ? "#FF53FF"
                              : "#431F66",
                          border: `1px solid ${
                            index < currentStep ? "#B3A9BE" : "#B3A9BE"
                          }`,
                        }}
                      />
                      // <ChevronRight
                      //   size={16}
                      //   color={index < currentStep ? "#23DC9F" : "#e9ecef"}
                      //   style={{ margin: "0 4px", flexShrink: 0 }}
                      // />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div> */}
          {/* Step Content */}
          <div className="rounded py-2 pt-md-4  px-2 backgroundColorCommon">
            {renderStepContent()}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default StepperForm;
